import * as React from 'react';

import classNames from 'classnames';

import { IMainMenuSetProps } from './types';

import * as s from './MainMenuSet.scss';

export const MainMenuSet: React.FunctionComponent<IMainMenuSetProps> = (props: IMainMenuSetProps ) => {
	const {
		className,
		title,
	} = props;

	return (
		<div className={classNames(className, s.block)}>
			{title && <div className={s.title}>{title}</div>}
			{props.children}
		</div>
	);
};
